import React from 'react';
import { useLocation } from 'react-router-dom';

const ComingSoon = () => {
  const location = useLocation();
  
  // Determine page title based on URL
  const getPageInfo = () => {
    const path = location.pathname.replace('/', '');
    const pageMap = {
      'api': { title: 'API Documentation', icon: '🔌', description: 'Developer-friendly REST API with comprehensive documentation' },
      'documentation': { title: 'Documentation', icon: '📚', description: 'Complete guides, tutorials, and best practices' },
      'blog': { title: 'Blog', icon: '✍️', description: 'Insights, updates, and industry trends' },
      'careers': { title: 'Careers', icon: '💼', description: 'Join our mission to transform venture capital' }
    };
    return pageMap[path] || { title: 'Coming Soon', icon: '🚀', description: 'Something exciting is on the way' };
  };

  const pageInfo = getPageInfo();

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '40px 20px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Animated background elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '10%',
        width: '300px',
        height: '300px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '50%',
        filter: 'blur(60px)',
        animation: 'float 6s ease-in-out infinite'
      }} />
      <div style={{
        position: 'absolute',
        bottom: '10%',
        right: '10%',
        width: '400px',
        height: '400px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '50%',
        filter: 'blur(80px)',
        animation: 'float 8s ease-in-out infinite reverse'
      }} />

      <div style={{ 
        maxWidth: '700px', 
        margin: '0 auto',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Icon */}
        <div style={{ 
          fontSize: '120px', 
          marginBottom: '32px',
          animation: 'bounce 2s ease-in-out infinite'
        }}>
          {pageInfo.icon}
        </div>

        {/* Main Content */}
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '24px',
          padding: '60px 40px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(10px)'
        }}>
          <div style={{ 
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#ede9fe',
            borderRadius: '24px',
            marginBottom: '24px'
          }}>
            <span style={{ color: '#7c3aed', fontSize: '14px', fontWeight: '600', letterSpacing: '0.5px' }}>
              COMING SOON
            </span>
          </div>

          <h1 style={{ 
            fontSize: '48px', 
            fontWeight: '800', 
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '20px',
            letterSpacing: '-1px',
            lineHeight: '1.1'
          }}>
            {pageInfo.title}
          </h1>

          <p style={{ 
            fontSize: '20px', 
            color: '#6b7280', 
            marginBottom: '40px',
            lineHeight: '1.6'
          }}>
            {pageInfo.description}
          </p>

          <div style={{
            padding: '24px',
            backgroundColor: '#f9fafb',
            borderRadius: '16px',
            marginBottom: '40px'
          }}>
            <p style={{ 
              fontSize: '16px', 
              color: '#4b5563',
              marginBottom: '20px',
              lineHeight: '1.6'
            }}>
              We're working hard to bring you this feature. Join our waitlist to be notified when it launches!
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <span style={{ fontSize: '24px' }}>⏳</span>
              <span style={{ fontSize: '24px' }}>🔨</span>
              <span style={{ fontSize: '24px' }}>✨</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div style={{ 
            display: 'flex', 
            gap: '16px', 
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <a 
              href="/"
              style={{
                display: 'inline-block',
                padding: '16px 32px',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: 'white',
                borderRadius: '12px',
                fontWeight: '700',
                textDecoration: 'none',
                fontSize: '16px',
                boxShadow: '0 8px 20px rgba(99, 102, 241, 0.3)',
                transition: 'transform 0.2s ease'
              }}
            >
              Join Waitlist
            </a>
            <a 
              href="/"
              style={{
                display: 'inline-block',
                padding: '16px 32px',
                backgroundColor: 'white',
                color: '#6366f1',
                border: '2px solid #e5e7eb',
                borderRadius: '12px',
                fontWeight: '700',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'all 0.2s ease'
              }}
            >
              ← Back to Home
            </a>
          </div>
        </div>

        {/* Additional Info */}
        <p style={{ 
          marginTop: '32px', 
          fontSize: '14px', 
          color: 'rgba(255, 255, 255, 0.9)',
          fontWeight: '500'
        }}>
          Want updates? Follow us on social media or contact us directly
        </p>
      </div>

      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
        `}
      </style>
    </div>
  );
};

export default ComingSoon;
